<template>
    <div class="index" ref="index">
    <div class="index-flash">
       <el-carousel :height="flashHeight" arrow="never" ref="carousel">
            <el-carousel-item>
                <div class="content flash">
                    <div class="gg">
                        <div><div class="topNav">产品</div></div>
                        <div class="title">RPA（机器人流程自动化）</div>
                        <div class="minTitle">可迅速实现业务提效，将重复性劳动进行自动化处理，高效低门槛连接不同业务系统。</div>
                        <div class="button" @click="$router.push('rpa')">了解详情</div>
                    </div>
                </div>
                <picture>
                    <source srcset="@/assets/images/mb_banner1.jpg" media="(max-width:768px)" alt="">
                    <img class="flashImg" ref="flashImg"  @load="loadFlashImg" src="@/assets/images/flash.png" />
                </picture>
            </el-carousel-item>
            <el-carousel-item>
                <div class="content flash">
                    <div class="gg">
                        <div><div class="topNav minColor">产品</div></div>
                        <div class="title">自动化测试</div>
                        <div class="minTitle minColor">颠覆传统、单一的软件测试服务模式，依托十余年自动化测试经验，结合专业测试工具，为企业客户提供功能测试、兼容测试、性能测试、安全测试等多种自动化测试服务。帮助企业客户从反复枯燥的低价值测试任务中解脱出来，提高测试效率与质量。</div>
                        <div class="button" @click="$router.push('zdhcs')">了解详情</div>
                    </div>
                </div>
                <picture>
                    <source srcset="@/assets/images/zd1_mb.jpg" media="(max-width:768px)" alt="">
                    <img class="flashImg" src="@/assets/images/zd1.png" />
                </picture>
            </el-carousel-item>
            <el-carousel-item>
                <div class="content flash">
                    <div class="gg">
                        <div><div class="topNav minColor">产品</div></div>
                        <div class="title">数据库工具</div>
                        <div class="minTitle minColor">是一款通用、迅速、稳定和全面的数据库管理专用工具，专为简化数据库的管理及数据管理成本而设计，可以让用户通过统一的桌面视图管理成千上万的异构数据库实例，具有图形界面直观，功能便捷的特点 。</div>
                        <div class="button" @click="$router.push('sjkgj')">了解详情</div>
                    </div>
                </div>
                <picture>
                    <source srcset="@/assets/images/gj1_mb.jpg" media="(max-width:768px)" alt="">
                    <img class="flashImg" src="@/assets/images/gj1.png" />
                </picture>

            </el-carousel-item>
            <!-- <el-carousel-item>
                <img class="flashImg" :style="'height:' + flashHeight" src="@/assets/images/flash.png" />
            </el-carousel-item> -->
        </el-carousel>
    </div>
        <div class="content">
            <div class="title1 tc mt20 mb10">高可靠、高安全、高品质的产品与服务</div>
            <div class="minTitle1 tc mb15">从核心设施领域，舟恩提供完善的产品体系，<span>助力您的业务腾飞</span></div>
        </div>
        <div class="content">
            <div class="contentImg mt10">
                
                <div class="fl item ml2" @click="$router.push('/zx')">
                    <img class="cImg" src="@/assets/images/c1.png" />
                    <div class="myTitle">咨询</div>
                    <div class="text">
                        舟恩为各行各业的客户提供战略、运营管理、信息技术、电子商务、人力资源、企业管理等咨询服务。舟恩凭借高质量专业服务，为客户提供深入见解以协助其应对最为复杂的业务挑战。
                    </div>
                </div>

                <div class="fl item itemCenter" @click="$router.push('/cs')">
                    <img class="cImg" src="@/assets/images/c2.png" />
                    <div class="myTitle">测试</div>
                    <div class="text">
                        舟恩经过多年在各个领域性能测试的经验积累，形成一整套从流程-规范-测试-定位-调优的完善的性能测试方法论。立体化安全防护体系，保卫您的信息安全。
                    </div>
                </div>

                <div class="fr item mr2" @click="$router.push('/yykf')">
                    <img class="cImg" src="@/assets/images/c3.png" />
                    <div class="myTitle">应用开发</div>
                    <div class="text">
                        舟恩为各行各业的客户提供战略、运营管理、信息技术、电子商务、人力资源、企业管理等咨询服务。舟恩凭借高质量专业服务，为客户提供深入见解以协助其应对最为复杂的业务挑战。
                    </div>
                </div>

            </div>
        </div>
        <el-carousel indicator-position="outside" arrow="never" class="servive" ref="carousel2" :autoplay="false">
            <el-carousel-item>
                <div class="fl item ml2" @click="$router.push('/zx')">
                    <div class="img">
                        <img class="cImg" src="@/assets/images/c1.png" />
                    </div>
                    <div class="con">
                        <div class="myTitle">咨询</div>
                        <div class="text">
                            舟恩为各行各业的客户提供战略、运营管理、信息技术、电子商务、人力资源、企业管理等咨询服务。舟恩凭借高质量专业服务，为客户提供深入见解以协助其应对最为复杂的业务挑战。
                        </div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item>
                <div class="fl item itemCenter" @click="$router.push('/cs')">
                    <div class="img">
                        <img class="cImg" src="@/assets/images/c2.png" />
                    </div>
                    <div class="con">
                        <div class="myTitle">测试</div>
                        <div class="text">
                            舟恩经过多年在各个领域性能测试的经验积累，形成一整套从流程-规范-测试-定位-调优的完善的性能测试方法论。立体化安全防护体系，保卫您的信息安全。
                        </div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item>
                <div class="fr item mr2" @click="$router.push('/yykf')">
                    <div class="img">
                        <img class="cImg" src="@/assets/images/c3.png" />
                    </div>
                    <div class="con">
                        <div class="myTitle">应用开发</div>
                        <div class="text">
                            舟恩为各行各业的客户提供战略、运营管理、信息技术、电子商务、人力资源、企业管理等咨询服务。舟恩凭借高质量专业服务，为客户提供深入见解以协助其应对最为复杂的业务挑战。
                        </div>
                    </div>
                </div>
            </el-carousel-item>
            <img style="width:100%;opacity: 0;" src="@/assets/images/c1.png" />
        </el-carousel>
        <div class="content">
            <div class="contentImg2 mt20 pc-contentImg2">
                <div class="imgBg tc" :class="activeIndex == 0? 'activeIndex': ''" @mouseenter="activeIndex = 0">
                    <img class="indexImg" src="@/assets/images/index1.png" />
                    <img class="indexImg1" src="@/assets/images/index1_1.png" />
                    <div class="title2 mb5">RPA</div>
                    <div class="minTitle2 mb20 tl">帮助企业或者员工完成重复单调的流程性工作，减少人工失误，提高运营效率，降低运营成本。</div>
                    <img class="indexImg2" src="@/assets/images/index42.png" />
                    <div class="tc">
                        <div class="button mt20" @click="$router.push('/rpa')">了解详情</div>
                    </div>
                </div>
                <div class="imgBg tc" :class="activeIndex == 1? 'activeIndex': ''" @mouseenter="activeIndex = 1">
                    <img class="indexImg" src="@/assets/images/index2.png" />
                    <img class="indexImg1" src="@/assets/images/index2_1.png" />
                    <div class="title2 mb5">自动化测试</div>
                    <div class="minTitle2 mb20 tl">节省人力、时间或硬件资源，提高测试效率，满足版本需求的快速迭代，提升产品测试质量。</div>
                    <img class="indexImg2" src="@/assets/images/index5.png" />
                    <div class="tc">
                        <div class="button mt20" @click="$router.push('/zdhcs')">了解详情</div>
                    </div>
                </div>
                <div class="imgBg tc" :class="activeIndex == 2? 'activeIndex': ''" @mouseenter="activeIndex = 2">
                    <img class="indexImg" src="@/assets/images/index3.png" />
                    <img class="indexImg1" src="@/assets/images/index3_1.png" />
                    <div class="title2 mb5">数据库工具</div>
                    <div class="minTitle2 mb20 tl">一般有储存、截取、安全保障、备份等基本功能。数据库管理工具主要完成数据管理的操作及管理功能，实现数据库管理工具对象的建立.数据库管理工具资料的查询。</div>
                    <img class="indexImg2" src="@/assets/images/index7.png" />
                    <div class="tc">
                        <div class="button mt20" @click="$router.push('/sjkgj')">了解详情</div>
                    </div>
                </div>
                <div class="imgBg tc" :class="activeIndex == 3? 'activeIndex': ''" @mouseenter="activeIndex = 3">
                    <img class="indexImg" src="@/assets/images/index4.png" />
                    <img class="indexImg1" src="@/assets/images/index4_1.png" />
                    <div class="title2 mb5">数据防泄露</div>
                    <div class="minTitle2 mb20 tl">智能化分析，实时敏感数据监测，异常行为及时触发警告。</div>
                    <img class="indexImg2" src="@/assets/images/index6.png" />
                    <div class="tc">
                        <div class="button mt20" @click="$router.push('/sjfxl')">了解详情</div>
                    </div>
                </div>
            </div>
            <div class="contentImg2 mt20 mb-contentImg2">
                <div class="imgBg tc" :class="activeIndex == 0? 'activeIndex': ''" @mouseenter="activeIndex = 0">
                    <div class="top">
                        <img class="indexImg" src="@/assets/images/index1.png" />
                        <img class="indexImg1" src="@/assets/images/index1_1.png" />
                        <div class="title2 mb5">RPA</div>
                    </div>
                    <div class="flex">
                        <div class="l">
                            <div class="minTitle2 mb20 tl">帮助企业或者员工完成重复单调的流程性工作，减少人工失误，提高运营效率，降低运营成本。</div>
                            <div class="tl">
                                <div class="button mt20" @click="$router.push('/rpa')">了解详情</div>
                            </div>
                        </div>
                        <div class="r">
                            <img class="indexImg2" src="@/assets/images/index42.png" />
                        </div>
                    </div>
                </div>
                <div class="imgBg tc" :class="activeIndex == 1? 'activeIndex': ''" @mouseenter="activeIndex = 1">
                    <div class="top">
                        <img class="indexImg" src="@/assets/images/index2.png" />
                        <img class="indexImg1" src="@/assets/images/index2_1.png" />
                        <div class="title2 mb5">自动化测试</div>
                    </div>
                    <div class="flex">
                        <div class="l">
                            <div class="minTitle2 mb20 tl">节省人力、时间或硬件资源，提高测试效率，满足版本需求的快速迭代，提升产品测试质量。</div>
                            <div class="tl">
                                <div class="button mt20" @click="$router.push('/zdhcs')">了解详情</div>
                            </div>
                        </div>
                        <div class="r">
                            <img class="indexImg2" src="@/assets/images/index5.png" />
                        </div>
                    </div>
                </div>
                <div class="imgBg tc" :class="activeIndex == 2? 'activeIndex': ''" @mouseenter="activeIndex = 2">
                    <div class="top">
                        <img class="indexImg" src="@/assets/images/index3.png" />
                        <img class="indexImg1" src="@/assets/images/index3_1.png" />
                        <div class="title2 mb5">数据库工具</div>
                    </div>
                    <div class="flex">
                        <div class="l">
                            <div class="minTitle2 mb20 tl">一般有储存、截取、安全保障、备份等基本功能。数据库管理工具主要完成数据管理的操作及管理功能，实现数据库管理工具对象的建立.数据库管理工具资料的查询。</div>
                            <div class="tl">
                                <div class="button mt20" @click="$router.push('/sjkgj')">了解详情</div>
                            </div>
                        </div>
                        <div class="r">
                            <img class="indexImg2" src="@/assets/images/index7.png" />
                        </div>
                    </div>
                </div>
                <div class="imgBg tc" :class="activeIndex == 3? 'activeIndex': ''" @mouseenter="activeIndex = 3">
                    <div class="top">
                        <img class="indexImg" src="@/assets/images/index4.png" />
                        <img class="indexImg1" src="@/assets/images/index4_1.png" />
                        <div class="title2 mb5">数据防泄露</div>
                    </div>
                    <div class="flex">
                        <div class="l">
                            <div class="minTitle2 mb20 tl">节省人力、时间或硬件资源，提高测试效率，满足版本需求的快速迭代，提升产品测试质量。</div>
                            <div class="tl">
                                <div class="button mt20" @click="$router.push('/sjfxl')">了解详情</div>
                            </div>
                        </div>
                        <div class="r">
                            <img class="indexImg2" src="@/assets/images/index6.png" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="contentTab mt15 pccontentTab">
            <div class="content">
                <div class="maxTitle">我们为不同行业提供更贴近业务的解决方案</div>
                <div class="minTitle1 tc">舟恩根据您的行业特点进行专属定制，打造贴合业务场景的客户关系管理解决方案</div>
                <div class="tabs">
                    <div class="tab" :class="tab == 0? 'active': ''" @click="tab = 0">房地产</div>
                    <div class="tab" :class="tab == 1? 'active': ''" @click="tab = 1">健康</div>
                    <div class="tab" :class="tab == 2? 'active': ''" @click="tab = 2">金融</div>
                    <div class="tab" :class="tab == 3? 'active': ''" @click="tab = 3">能源</div>
                    <div class="tab" :class="tab == 4? 'active': ''" @click="tab = 4">汽车</div>
                    <div class="tab" :class="tab == 5? 'active': ''" @click="tab = 5">快消</div>
                    <div class="tab" :class="tab == 6? 'active': ''" @click="tab = 6">康养</div>
                </div>
                <div class="tabContetn" v-show="tab == 0">
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">房地产行业解决方案</div>
                        <div class="minTitle1">充分结合房地产企业业务管理经验，并将其融入到房地产行业解决方案中，提供了一套完整的、覆盖各业务环节的最佳应用实践。方案按房地产行业业务流程可细分为：经营管理、设计管理、计划管理、招采管理、成本管理、工程项目管理、售楼管理、商业物业服管理以及主数据管理。</div>
                        <div class="button mt20" @click="$router.push('/fdc')">了解详情</div>
                    </div>
                    <div class="tabLine"></div>
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">
                            <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                        </div>
                        <div class="minTitle1">舟恩的资金管理解决方案实现了对资金计划、账户、结算、票据、银企对账、融资的管理，使财务数据集 中、实施、可追溯，提高了资金管理水平，加速资金周转。</div>
                        
                        <div class="buttons mt20">
                            <span>涉及产品： </span>
                            <div class="navItems">
                                <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tabContetn" v-show="tab == 1">
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">健康行业解决方案</div>
                        <div class="minTitle1">通过整合不同业务系统中数据，连接孤岛，提高数字资产价值。多角度分析、全方位集成，迅速准确地定位业务与管理短板所在。通过前端可视化工具聚焦重点，满足多层次管理需求。</div>
                        <div class="button mt20" @click="$router.push('/jk')">了解详情</div>
                    </div>
                    <div class="tabLine"></div>
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">
                            <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                        </div>
                        <div class="minTitle1">药品集采的推广必将提高行业集中度。优胜劣汰，药企面临着更大的生存压力，产品质、量和成本必须全 面改善。原料和人工成本的上涨与集采带来的价格下行压力相叠加，首要的问题就是成本控制。</div>
                        
                        <div class="buttons mt20">
                            <span>涉及产品： </span>
                            <div class="navItems">
                                <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                <div class="myByttom" @click="$router.push('/rpa')">RPA</div>
                                <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tabContetn" v-show="tab == 2">
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">金融行业解决方案</div>
                        <div class="minTitle1">基于金融业提供端到端的科技信息化业务服务，积累了丰富的业务和技术知识。公司具备安全稳定的产品和定制化信息技术服务能力，拥有一支经验丰富的金融业服务团队和技术支撑团队，结合自身优势和客户需求，为客户打造真正有价值的金融科技信息化业务解决方案。</div>
                        <div class="button mt20" @click="$router.push('/jr')">了解详情</div>
                    </div>
                    <div class="tabLine"></div>
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">
                            <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                        </div>
                        <div class="minTitle1">专注于金融行业领域，在银行、保险、基金、证券等业务有着深厚的案例积累，为客户提供全方位的技术 服务，解决方案。助力客户实现随需应变，构建灵活、创新、完整、专业的业务体系。</div>
                        
                        <div class="buttons mt20">
                            <span>涉及产品： </span>
                            <div class="navItems">
                                <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                                <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                                <div class="myByttom" @click="$router.push('/sjfxl')">数据防泄漏</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tabContetn" v-show="tab == 3">
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">新能源行业解决方案</div>
                        <div class="minTitle1">投资决策模型数字化平台、全生命周期管理云平台</div>
                        <div class="button mt20" @click="$router.push('/xny')">了解详情</div>
                    </div>
                    <div class="tabLine"></div>
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">
                            <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                        </div>
                        <div class="minTitle1">构建了基于项目投资、建设、融资、运营、财务和经营一体化的全生命周期管理机制，实现项目信息共享 共用、实时跟踪项目进展和项目的全生命周期追溯与管理。</div>
                        
                        <div class="buttons mt20">
                            <span>涉及产品： </span>
                            <div class="navItems">
                                <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                                <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tabContetn" v-show="tab == 4">
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">汽车行业解决方案</div>
                        <div class="minTitle1">汽车制造行业-项目品质全面提升方案</div>
                        <div class="button mt20" @click="$router.push('/qc')">了解详情</div>
                    </div>
                    <div class="tabLine"></div>
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">
                            <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                        </div>
                        <div class="minTitle1">建立品质保证和品质控制体系，提供品质监测、品质咨询、体系建立服务</div>
                        
                        <div class="buttons mt20">
                            <span>涉及产品： </span>
                            <div class="navItems">
                                <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                <div class="myByttom" @click="$router.push('/rpa')">RPA</div>
                                <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                                <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                                <div class="myByttom" @click="$router.push('/sjfxl')">数据防泄漏</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tabContetn" v-show="tab == 5">
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">快消行业解决方案</div>
                        <div class="minTitle1">通过湖仓一体化的数据平台，对基础的数据、指标和报表进行加工与整合，建立数据指标体系，优化数据结构, 最终归纳成业务主题， 让数据为业务服务。</div>
                        <div class="button mt20" @click="$router.push('/kx')">了解详情</div>
                    </div>
                    <div class="tabLine"></div>
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">
                            <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                        </div>
                        <div class="minTitle1">对基础的数据、指标和报表进行加工与整合，建立数据指标体系，优化数据结构, 最终归纳成业务主 题。 让数据为业务服务</div>
                        
                        <div class="buttons mt20">
                            <span>涉及产品： </span>
                            <div class="navItems">
                                <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                                <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                <div class="myByttom" @click="$router.push('/rpa')">RPA</div>
                                <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tabContetn" v-show="tab == 6">
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">康养行业解决方案</div>
                        <div class="minTitle1">通过智能化的照护体系，利用先进的评估模型为长者建立个性化照护服务方案。以自研的软硬件利用科技和数据为核心建立以长者为中心的7*24小时全天后服务机制。通过智能化的软件的相结合为养老行业建立统一的服务调度平台。提高养老行业资源调度能力和服务管理效率。打造具备实时，智能，精细，可视，多维的行业智能化服务平台，助力养老行业数字化转型。</div>
                        <div class="button mt20" @click="$router.push('/ky')">了解详情</div>
                    </div>
                    <div class="tabLine"></div>
                    <div class="tabContent">
                        <div class="maxTitle2 mt20 mb20">
                            <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                        </div>
                        <div class="minTitle1">一体化软硬件整合，各种功能无缝连接，更贴近机构管理；标准化的业务管理，多达20多个量表贯穿整个 业务过程；模块化设计，根据实际管理深度适配最合适的模块</div>
                        
                        <div class="buttons mt20">
                            <span>涉及产品： </span>
                            <div class="navItems">
                                <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                                <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                                <div class="myByttom" @click="$router.push('/sjfxl')">数据防泄漏</div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <div class="mbcontentTab">
            <div class="content">
                <div class="maxTitle">我们为不同行业提供更贴近业务的解决方案</div>
                <div class="minTitle1 tc">舟恩根据您的行业特点进行专属定制，打造贴合业务场景的客户关系管理解决方案</div>
            </div>
            <div class="contentTab mt15">
                <div class="content">
                <el-carousel indicator-position="outside" arrow="never" class="mbcontentCarousel" ref="carousel3" :autoplay="false">
                    <el-carousel-item>
                        <div class="tabContetn">
                            <div class="tabContent">
                                <div class="maxTitle2 mt20 mb20">房地产行业解决方案</div>
                                <div class="minTitle1">充分结合房地产企业业务管理经验，并将其融入到房地产行业解决方案中，提供了一套完整的、覆盖各业务环节的最佳应用实践。方案按房地产行业业务流程可细分为：经营管理、设计管理、计划管理、招采管理、成本管理、工程项目管理、售楼管理、商业物业服管理以及主数据管理。</div>
                                <div class="button mt20" @click="$router.push('/fdc')">了解详情</div>
                            </div>
                            <div class="tabLine"><img src="@/assets/images/line.png" alt=""></div>
                            <div class="tabContent">
                                <div class="maxTitle2 mt20 mb20">
                                    <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                                </div>
                                <div class="minTitle1">舟恩的资金管理解决方案实现了对资金计划、账户、结算、票据、银企对账、融资的管理，使财务数据集 中、实施、可追溯，提高了资金管理水平，加速资金周转。</div>
                                
                                <div class="buttons mt20">
                                    <div class="navItems">
                                        <span>涉及产品： </span>
                                        <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                        <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                        <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <div class="tabContetn">
                            <div class="tabContent">
                                <div class="maxTitle2 mt20 mb20">健康行业解决方案</div>
                                <div class="minTitle1">通过整合不同业务系统中数据，连接孤岛，提高数字资产价值。多角度分析、全方位集成，迅速准确地定位业务与管理短板所在。通过前端可视化工具聚焦重点，满足多层次管理需求。</div>
                                <div class="button mt20" @click="$router.push('/jk')">了解详情</div>
                            </div>
                            <div class="tabLine"><img src="@/assets/images/line.png" alt=""></div>
                            <div class="tabContent">
                                <div class="maxTitle2 mt20 mb20">
                                    <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                                </div>
                                <div class="minTitle1">药品集采的推广必将提高行业集中度。优胜劣汰，药企面临着更大的生存压力，产品质、量和成本必须全 面改善。原料和人工成本的上涨与集采带来的价格下行压力相叠加，首要的问题就是成本控制。</div>
                                
                                <div class="buttons mt20">
                                    <div class="navItems">
                                        <span>涉及产品： </span>
                                        <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                        <div class="myByttom" @click="$router.push('/rpa')">RPA</div>
                                        <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                        <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <div class="tabContetn">
                            <div class="tabContent">
                                <div class="maxTitle2 mt20 mb20">金融行业解决方案</div>
                                <div class="minTitle1">基于金融业提供端到端的科技信息化业务服务，积累了丰富的业务和技术知识。公司具备安全稳定的产品和定制化信息技术服务能力，拥有一支经验丰富的金融业服务团队和技术支撑团队，结合自身优势和客户需求，为客户打造真正有价值的金融科技信息化业务解决方案</div>
                                <div class="button mt20" @click="$router.push('/jr')">了解详情</div>
                            </div>
                            <div class="tabLine"><img src="@/assets/images/line.png" alt=""></div>
                            <div class="tabContent">
                                <div class="maxTitle2 mt20 mb20">
                                    <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                                </div>
                                <div class="minTitle1">专注于金融行业领域，在银行、保险、基金、证券等业务有着深厚的案例积累，为客户提供全方位的技术 服务，解决方案。助力客户实现随需应变，构建灵活、创新、完整、专业的业务体系。</div>
                                
                                <div class="buttons mt20">
                                    <div class="navItems">
                                        <span>涉及产品： </span>
                                        <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                        <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                        <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                                        <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                                        <div class="myByttom" @click="$router.push('/sjfxl')">数据防泄漏</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <div class="tabContetn">
                            <div class="tabContent">
                                <div class="maxTitle2 mt20 mb20">新能源行业解决方案</div>
                                <div class="minTitle1">投资决策模型数字化平台、全生命周期管理云平台</div>
                                <div class="button mt20" @click="$router.push('/xny')">了解详情</div>
                            </div>
                            <div class="tabLine"><img src="@/assets/images/line.png" alt=""></div>
                            <div class="tabContent">
                                <div class="maxTitle2 mt20 mb20">
                                    <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                                </div>
                                <div class="minTitle1">构建了基于项目投资、建设、融资、运营、财务和经营一体化的全生命周期管理机制，实现项目信息共享 共用、实时跟踪项目进展和项目的全生命周期追溯与管理。</div>
                                
                                <div class="buttons mt20">
                                    <div class="navItems">
                                        <span>涉及产品： </span>
                                        <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                        <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                        <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                                        <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                    <el-carousel-item>
                    <div class="tabContetn">
                        <div class="tabContent">
                            <div class="maxTitle2 mt20 mb20">汽车行业解决方案</div>
                            <div class="minTitle1">汽车制造行业-项目品质全面提升方案</div>
                            <div class="button mt20" @click="$router.push('/qc')">了解详情</div>
                        </div>
                        <div class="tabLine"><img src="@/assets/images/line.png" alt=""></div>
                        <div class="tabContent">
                            <div class="maxTitle2 mt20 mb20">
                                <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                            </div>
                            <div class="minTitle1">建立品质保证和品质控制体系，提供品质监测、品质咨询、体系建立服务</div>
                            
                            <div class="buttons mt20">
                                <div class="navItems">
                                    <span>涉及产品： </span>
                                    <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                    <div class="myByttom" @click="$router.push('/rpa')">RPA</div>
                                    <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                    <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                                    <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                                    <div class="myByttom" @click="$router.push('/sjfxl')">数据防泄漏</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <div class="tabContetn">
                            <div class="tabContent">
                                <div class="maxTitle2 mt20 mb20">快消行业解决方案</div>
                                <div class="minTitle1">通过湖仓一体化的数据平台，对基础的数据、指标和报表进行加工与整合，建立数据指标体系，优化数据结构, 最终归纳成业务主题， 让数据为业务服务。</div>
                                <div class="button mt20" @click="$router.push('/kx')">了解详情</div>
                            </div>
                            <div class="tabLine"><img src="@/assets/images/line.png" alt=""></div>
                            <div class="tabContent">
                                <div class="maxTitle2 mt20 mb20">
                                    <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                                </div>
                                <div class="minTitle1">对基础的数据、指标和报表进行加工与整合，建立数据指标体系，优化数据结构, 最终归纳成业务主 题。 让数据为业务服务</div>
                                
                                <div class="buttons mt20">
                                    <div class="navItems">
                                        <span>涉及产品： </span>
                                        <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                                        <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                        <div class="myByttom" @click="$router.push('/rpa')">RPA</div>
                                        <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                        <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                    <el-carousel-item>
                    <div class="tabContetn">
                        <div class="tabContent">
                            <div class="maxTitle2 mt20 mb20">康养行业解决方案</div>
                            <div class="minTitle1">通过智能化的照护体系，利用先进的评估模型为长者建立个性化照护服务方案。以自研的软硬件利用科技和数据为核心建立以长者为中心的7*24小时全天后服务机制。通过智能化的软件的相结合为养老行业建立统一的服务调度平台。提高养老行业资源调度能力和服务管理效率。打造具备实时，智能，精细，可视，多维的行业智能化服务平台，助力养老行业数字化转型。</div>
                            <div class="button mt20" @click="$router.push('/ky')">了解详情</div>
                        </div>
                        <div class="tabLine"><img src="@/assets/images/line.png" alt=""></div>
                        <div class="tabContent">
                            <div class="maxTitle2 mt20 mb20">
                                <!-- <img  height="23" src="@/assets/images/wdjt.png" /> -->
                            </div>
                            <div class="minTitle1">一体化软硬件整合，各种功能无缝连接，更贴近机构管理；标准化的业务管理，多达20多个量表贯穿整个 业务过程；模块化设计，根据实际管理深度适配最合适的模块</div>
                            
                            <div class="buttons mt20">
                                <div class="navItems">
                                    <span>涉及产品： </span>
                                    <div class="myByttom" @click="$router.push('/zx')">咨询</div>
                                    <div class="myByttom" @click="$router.push('/yykf')">应用开发</div>
                                    <div class="myByttom" @click="$router.push('/cs')">自动化测试</div>
                                    <div class="myByttom" @click="$router.push('/sjkgj')">数据库工具</div>
                                    <div class="myByttom" @click="$router.push('/sjfxl')">数据防泄漏</div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    </el-carousel-item>
                </el-carousel>
                </div>
            </div> 
        </div>
        
    </div>
</template>


<script>
import { Carousel, CarouselItem } from 'element-ui'
    export default {
        components: {
            [Carousel.name]: Carousel,
            [CarouselItem.name]: CarouselItem
        },
        data() {
            return {
                windowWidth: '', //获取屏幕宽度
                flashHeight: '401px',  // flash高度
                activeIndex: 0,
                tab: 0   // 显示的tab
            }
        },
        methods: {
            loadFlashImg() {
                this.flashHeight = (this.$refs.flashImg.height + 10)  + 'px'
                var that = this
                window.onresize = () => {
                    return (() => {
                        that.windowWidth = that.$refs.index.offsetWidth //获取屏幕宽度
                    })()
                }
            },
            startAuto() {
                var that = this
                if(that.autoplay == false){
                    that.autoplay = true;
                }
            },
            stopAuto() {
                var that = this
                if(that.autoplay == true){
                    that.autoplay = false;
                }
            },
            slideBanner1() {
                var that = this
                var box = document.querySelector('.index-flash .el-carousel__container');
                var startPoint = 0;
                var stopPoint = 0;
                
                var resetPoint =  function(){
                    startPoint = 0;
                    stopPoint = 0;
                }
                
                
                box.addEventListener("touchstart",function(e){
                    that.stopAuto();
                    startPoint = e.changedTouches[0].pageX;
                });
                
                box.addEventListener("touchmove",function(e){
                    stopPoint = e.changedTouches[0].pageX;
                });
                box.addEventListener("touchend",function(e){
                if(stopPoint == 0 || startPoint - stopPoint == 0){
                    resetPoint();
                        return;
                    }
                    if(startPoint - stopPoint > 0){
                        resetPoint();
                        that.$refs.carousel.next();
                        return;
                    }
                    if(startPoint - stopPoint < 0){
                        resetPoint();
                        that.$refs.carousel.prev();
                        return;
                    }
                });
            },
            slideBanner2() {
                var that = this
                var box = document.querySelector('.servive .el-carousel__container');
                var startPoint = 0;
                var stopPoint = 0;
                
                var resetPoint =  function(){
                    startPoint = 0;
                    stopPoint = 0;
                }
                
                
                box.addEventListener("touchstart",function(e){
                    that.stopAuto();
                    startPoint = e.changedTouches[0].pageX;
                });
                
                box.addEventListener("touchmove",function(e){
                    stopPoint = e.changedTouches[0].pageX;
                });
                box.addEventListener("touchend",function(e){
                if(stopPoint == 0 || startPoint - stopPoint == 0){
                    resetPoint();
                        return;
                    }
                    if(startPoint - stopPoint > 0){
                        resetPoint();
                        that.$refs.carousel2.next();
                        return;
                    }
                    if(startPoint - stopPoint < 0){
                        resetPoint();
                        that.$refs.carousel2.prev();
                        return;
                    }
                });
            },
            slideBanner3() {
                var that = this
                var box = document.querySelector('.mbcontentCarousel .el-carousel__container');
                var startPoint = 0;
                var stopPoint = 0;
                
                var resetPoint =  function(){
                    startPoint = 0;
                    stopPoint = 0;
                }
                
                
                box.addEventListener("touchstart",function(e){
                    that.stopAuto();
                    startPoint = e.changedTouches[0].pageX;
                });
                
                box.addEventListener("touchmove",function(e){
                    stopPoint = e.changedTouches[0].pageX;
                });
                box.addEventListener("touchend",function(e){
                if(stopPoint == 0 || startPoint - stopPoint == 0){
                    resetPoint();
                        return;
                    }
                    if(startPoint - stopPoint > 0){
                        resetPoint();
                        that.$refs.carousel3.next();
                        return;
                    }
                    if(startPoint - stopPoint < 0){
                        resetPoint();
                        that.$refs.carousel3.prev();
                        return;
                    }
                });
            },
        },
        watch: {
            windowWidth (val) {
                this.flashHeight = (this.$refs.flashImg.height - 10)  + 'px'
            }
        },
        mounted() {
            this.slideBanner1()
            this.slideBanner2()
            this.slideBanner3()
        }
    }
</script>

<style lang="less" scoped>
.index {
    background-color: #f8fcfd;
    .index-flash {
        /deep/ .el-carousel__indicators--horizontal {
            bottom: 10px;
        }
    }
    .flash {
        /deep/ .el-carousel__container {
            height: 520px;
        }
        
    }
    .flashImg {
        width: 100%;
        vertical-align: bottom;
    }
    .myTitle {
        font-size: 20px;
        color: #FFFFFF;
        line-height: 60px;
        margin-top: -60px;
        text-indent: 30px;
        font-weight: 500;
    }
    .contentImg {
        display: flex;
        justify-content: space-between;
        zoom: 1;
        overflow: hidden;
        .mr2 {
            margin-right: 2px;
        }
        .ml2 {
            margin-left: 2px;
        }
        .item {
            width: 30%;
            margin-bottom: 2px;
            cursor: pointer;
            background: #ffffff;
            border-bottom-right-radius: 25px;
            border-bottom-left-radius: 25px;
            box-shadow: 0px 0px 5px #d3d2d2;
            .cImg {
                width: 100%;
            }
            .text {
                font-size: 12px;
                font-family: PingFang SC;
                color: #333333;
                line-height: 17px;
                padding: 15px 30px 20px;
                margin-top: -5px;
                min-height: 70px;
            }
        }
        .itemCenter {
            margin-left: 0;
        }
    }
    .contentImg2 {
        display: flex;
        flex-wrap: wrap;
        .imgBg {
            width: calc(21% - 2px);
            background: #ffffff;
            border: 1px solid #ffebe9;
            border-radius: 20px;
            padding: 40px 2%;
            min-height: 270px;
            .indexImg {
                width: 25px;
                height: 25px;
                margin-bottom: 15px;
            }
            .indexImg1 {
                display: none;
                width: 25px;
                height: 25px;
                margin-bottom: 15px;
            }
            .indexImg2 {
                height: 100px;
                margin: 0 auto;
                display: block;
            }
            .button {
                display: none;
            }
        }
        .activeIndex {
            background: url(../assets/images/imgBg2.png) no-repeat;
            background-size: 100% 100%;
            text-align: left;
            padding-top: 13px;
            .indexImg {
                width: 25px;
                height: 25px;
                margin-right: 10px;
                display: none;
            }
            .indexImg1 {
                width: 25px;
                height: 25px;
                margin-right: 10px;
                display: inline-block;
            }
            .title2 {
                display: inline-block;
                color: #ffffff;
                line-height: 25px;
                vertical-align: top;
            }
            .minTitle2 {
                margin-top: 13px;
            }
            .indexImg2 {
                height: 100px;
            }
            .button {
                display: inline-block;
                padding: 5px 10px;
                border-radius: 4px;
                background-color: #E60012;
                cursor: pointer;
                color: #FFFFFF;
                font-size: 14px;
            }
        }
        .indexImg3 {
            height: 100px;
        }
        .imgBg2 {
            width: 430px;
            padding: 0px 20px 20px;
            background: url(../assets/images/imgBg2.png) no-repeat;
            background-size: 100% 100%;
            .imgTitle {
                margin-left: 20px;
                text-align: left;
                img {
                    width: 25px;
                }
                span {
                    font-size: 18px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 30px;
                    margin-left: 8px;
                    vertical-align: bottom;
                }
            }
            .text {
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 21px;
                text-align: left;
                padding: 20px 0;
            }
            .button {
                display: inline-block;
                padding: 5px 10px;
                border-radius: 4px;
                background-color: #E60012;
                cursor: pointer;
                color: #FFFFFF;
                font-size: 14px;
            }
        }
    }
    .pc-contentImg2 {
        display: flex;
    }
    .mb-contentImg2 {
        display: none;
        .top {
            display: flex;
            align-items: center;
            padding: 10px 5%;
        }
        .flex {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding: 0 5%;
        }
        .imgBg {
            padding: 0;
            padding-bottom: 25px;
            background: unset;
            text-align: left;
            border: 1px solid #eeeded;
            overflow: hidden;
            border-radius: 20px;
            min-height: unset;
            .indexImg1 {
                margin-right: 0;
                margin-bottom: 0;
            }
            .button {
                display: inline-block;
                border: 1px solid #E60012;
                background-color: #fff;
                padding: 5px 10px;
                color: #E60012;
            }
            .indexImg {
                margin-right: 0;
                margin-bottom: 0;
            }
        }
        .minTitle2 {
            margin-top: 15px;
            padding-left: 10px;
            margin-bottom: 0;
        }
        .activeIndex .minTitle2 {
            margin-top: 15px;
        }
        .imgBg.activeIndex {
            border-color: #f8462c;
        }
        .imgBg.activeIndex .top {
            background-image: linear-gradient(to right, #e70213 , #ff6136);
            
        }
        .imgBg .title2 {
            margin-top: 0;
            padding-left: 10px;
            margin-bottom: 0;
        }
        .imgBg.activeIndex .title2 {
            display: inline-block;
            color: #fff;
            line-height: 25px;
            vertical-align: top;
        }
    }
    .contentTab {
        min-height: 400px;
        background: url(../assets/images/index9.png) no-repeat;
        background-size: 100% 100%;
        padding-bottom: 60px;
        .maxTitle {
            text-align: center;
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            padding-top: 45px;
            margin-bottom: 15px;
        }
        .tabs {
            margin-top: 30px;
            margin-left: 10px;
            .tab {
                display: inline-block;
                text-align: center;
                width: 140px;
                line-height: 45px;
                font-size: 14px;
                color: #FFFFFF;
                font-weight: 400;
                cursor: pointer;
            }
            .tab:hover {
                color: #E60012;
            }
            .tab:hover.active {
                color: #ffffff;
            }
            .active {
                background: url(../assets/images/index10.png) no-repeat;
                background-size: 100% 100%;
            }
        }
        .tabContetn {
            padding: 20px 0;
            border: 1px solid #545569;
            margin-top: -2px;
            display: flex;
            flex-wrap: wrap;
            .tabContent {
                width: 41.5%;
                min-height: 220px;
                padding: 0px 5% 0 3%;
                .maxTitle2 {
                    font-size: 20px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }
                .button {
                    display: inline-block;
                    padding: 7px 13px;
                    border-radius: 4px;
                    border: 1px solid #545569;
                    cursor: pointer;
                    color: #FFFFFF;
                    font-size: 14px;
                }
                .button:hover{
                    color: #fff;
                }
                .buttons {
                    color: #c8c8cb;
                    .navItems {
                        margin-left: 70px;
                        margin-top: -22px;
                    }
                    .myByttom {
                        display: inline-block;
                        margin-right: 8px;
                        cursor: pointer;
                        padding: 4px 12px;
                        border: 1px solid #FFFFFF;
                        border-radius: 20px;
                        color: #ffffff;
                        margin-bottom: 10px;
                    }
                    .myByttom:hover {
                        color: #E60012;
                    }
                }
            }
            .tabLine {
                background: url(../assets/images/index11.png) no-repeat;
                background-size: auto 100%;
                width: 1%;
            }
        }
    }
    .mbcontentTab {
        .contentTab {
            min-height: 500px;
            padding: 35px 0 25px;
            background-position: right bottom;
            background-size: center/cover;
        }
        /deep/ .el-carousel__container {
            height: 520px;
        }
        .buttons {
            margin-top: 30px;
        }
        .buttons .navItems {
            display: flex;
            flex-wrap: wrap;
            align-items: baseline;
            justify-content: flex-start;
           
        }
        .maxTitle2 {
            margin-bottom: 12px !important;
        }
        .tabContetn .tabContent {
            width: 100%;
            min-height: unset;
            padding: 0;
            text-align: center;
        }
        .tabContetn .tabLine {
            margin: 20px 0;
            background: unset;
            width: 100%;
            height: 100%; 
            text-align: center;
            img {
                max-width: 100%;
            }
        }
        .tabContent .buttons {
            display: flex;
            flex-wrap: wrap;
        }
        .maxTitle2 {
            font-size: 16px;
            margin: 0;
        }
        .minTitle1 {
            margin-bottom: 0;
        }
        .tabContent .minTitle1 {
            text-align: left;
        }
        .tabContetn {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: none;
        }
        .contentTab .tabContent .buttons .navItems {
            margin-left: 0;
            margin-top: 0;
        }
        .maxTitle {
            text-align: center;
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            padding-top: 45px;
            margin-bottom: 15px;
        }
        .minTitle1 {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #999999;
        }
        .tabContetn .tabContent .button {
            margin-top: 30px;
            color: #ffffff;
            border: 1px solid #ff3230;
            background-color: #ff3230;
        }
    }
    .servive {
        display: none;
    }
    .servive /deep/ .el-carousel__container {
        height: auto;
    }
    .servive /deep/ .el-carousel__indicators--outside {
        margin-top: 20px;
    }
    .servive /deep/ .el-carousel__indicators--outside button {
        width: 32px;
        height: 4px;
        border-radius: 2px;
        background-color: #afafaf;
        opacity: 1;
    }
    .servive /deep/ .el-carousel__indicator.is-active button {
        background-color: #e60012;
    }
    .servive .item {
        position: relative;
        width: 100%;
        .img {
            width: 100%;
            img {
                width: 100%;
            }
        }
        .con {
            position: absolute;
            padding: 0 30px;
            left: 0;
            right: 0;
            bottom: 15%;
            .myTitle {
                font-size: 18px;
                color: #FFFFFF;
                line-height: 3;
                margin-top: 0;
                text-indent: 0;
            }
            .text {
                color: #FFFFFF;
            }
        }

    }
    .mbcontentTab {
        display: none;
    }
}
</style>
<style lang="less" scoped>
    @media (max-width: 1230px) {
        .index {
            .flash {
                position: relative;
                padding: 0 50px;
                .gg .title {
                    font-size: 24px;
                }
            }
            .flashImg {
                height: 100vh;
            }  
        }
    }
    @media (max-width: 960px) {
      .flash {
          .gg {
              .title {
                  font-size: 20px;
              }
              .minTitle {
                  width: 40%;
                  font-size: 13px;
              }
              .button {
                  padding: 6px 15px;
                  margin-top: 20px;
              }
          }
      }
      .index .contentImg .item {
            width: 32.5%;
        }
       
        .index .contentImg2 {
            justify-content: space-between;
        }
        .index .contentImg2 .imgBg {
            width: 48%;
            margin-bottom: 15px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .index .myTitle {
            font-size: 16px;
            line-height: 34px;
            margin-top: -40px;
            text-indent: 20px;
        }
        .index .contentImg .item .text {
            line-height: 17px;
            padding: 16px 20px 20px;
        }
        .index .pc-contentImg2 {
            display: none;
        }
        .index .mb-contentImg2 {
            display: flex;
        }
        
    }
    @media (max-width: 768px) {
        .index {
            .flash {
                padding: 0 15px;
                .minTitle {
                    width: 50%;
                    font-size: 13px;
                }
                .gg {
                    top: 50px;
                    .title {
                        font-size: 20px;
                    }
                    .button {
                        padding: 6px 15px;
                        margin-top: 20px;
                    }
                }
                
            }
            /deep/ .el-carousel__indicators--horizontal {
                bottom: 10px;
            }
            .flashImg {
                
            }  
            .contentImg {
                display: none;
            }
            .servive {
                display: block;
            } 
            .contentImg2 .imgBg {
                width: 100%;
                .l {
                    margin-right: 15px;
                }
                .indexImg2 {
                    height: 80px;
                }
            }
            .mb-contentImg2 .flex {
                padding-top: 10px;
                align-items: center;
            }
            .contentImg2  .button {
                padding: 4px 8px !important;
                font-size: 13px !important;
            }
            .pccontentTab {
                display: none;
            }
            .mbcontentTab {
                display: block;
            }
            .mb-contentImg2 .minTitle2 {
                padding-left: 0;
                font-size: 14px;
            }
            .servive /deep/ .el-carousel__indicators--outside {
                margin-top: 10px;
            }
            .mbcontentTab .maxTitle {
                font-size: 20px;
                padding-top: 30px;
                margin-bottom: 15px;
            }
        }
    }
</style>
